import React from "react";
import FixtureTable from "components/feature/fixtureTable/FixtureTable";
import { FadeIn } from "components/shared";

const Fixtures = (props) => <FixtureTable cardTitle="Fixtures" />;

export default Fixtures;
